import type { TRadioSizes } from '../../types'
import * as Comp from './radio.label.styles'

type TRadioLabelProps = {
  children: string
  size?: TRadioSizes
  error?: boolean
  disabled?: boolean
  readOnly?: boolean
  testID?: string
}

export function RadioLabel({
  children,
  size,
  error,
  disabled,
  readOnly,
  testID,
}: TRadioLabelProps) {
  const componentProperties = {
    size,
    hasError: !!error,
    hasDisabled: !!disabled,
    hasReadOnly: !!readOnly && !disabled,
    numberOfLines: 4,
  }

  return (
    <Comp.Label testID={testID} {...componentProperties}>
      {children}
    </Comp.Label>
  )
}
